import { render, staticRenderFns } from "./appointmentdetail.vue?vue&type=template&id=75ab845d&scoped=true&"
import script from "./appointmentdetail.vue?vue&type=script&lang=js&"
export * from "./appointmentdetail.vue?vue&type=script&lang=js&"
import style0 from "./appointmentdetail.vue?vue&type=style&index=0&id=75ab845d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ab845d",
  null
  
)

export default component.exports